import { CopyProperties } from "src/app/shared/decorator/copy-properties.decorator";
import { NumberUtil } from "src/app/shared/util/number.util";

@CopyProperties()
export class ValueRange {
  beginValue: any;
  beginOperatorCode: string;
  endOperatorCode: string;
  endValue: any;
  keyValue: any;
  fee: any;
  id: any;
  typeCode: string;
  description: string;
  note: string;
  constructor(
    params?: any
  ) {
    this.beginValue = undefined ;
    this.endValue = undefined ;
    this.keyValue = undefined ;
    this.fee = undefined ;
    this.id = null;
    this.beginOperatorCode = '';
    this.endOperatorCode = '';
    this.typeCode = '';
    this.note = '';
    this.description = '';
  }
}
